import React, {useEffect, useRef, useState} from 'react'
import Container from "@mui/material/Container";
import axios from 'axios';
import {AED_PRICE, PRODUCTS_URL} from "../config";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import {makeStyles} from "@mui/styles";
import Grid from "@mui/material/Grid";
import {Link} from 'react-router-dom'
import TextField from "@mui/material/TextField/TextField";
import green from "@mui/material/colors/green";
import {deepOrange} from "@mui/material/colors";
import Button from "@mui/material/Button";

export default function HomePage() {

    const [products, setProducts] = useState([]);
    const [aedPrice, setAedPrice] = useState(0);
    const [searchPhrase, setSearchPhrase] = useState('');
    const aedRef = useRef();

    const IRRFormatter = new Intl.NumberFormat('fa-IR', {style: 'currency', currency: 'IRR', maximumFractionDigits: 0});
    const AEDFormatter = new Intl.NumberFormat('fa-IR', {style: 'currency', currency: 'AED', maximumFractionDigits: 0});

    async function fetchAEDData() {
        const {data} = await axios.get(AED_PRICE);

        const {value} = data;
        setAedPrice(value)
    }

    async function fetchProductsData() {
        const {data} = await axios.get(PRODUCTS_URL);
        const productsData = data.map(d => ({...d, profit: calculateProfit(d)}));
        productsData.sort((a, b) => b.profit - a.profit);
        setProducts(productsData)

    }

    async function handleSubmit(e) {
        e.preventDefault();
        if (!aedRef.current.value)
            return;

        try {
            await axios.post(`${AED_PRICE}`,
                {value: aedRef.current.value},
                {headers: {'Content-Type': 'application/json'}});
            window.location.reload()
        } catch {

        }
    }


    useEffect(() => {
        fetchAEDData().then(() => fetchProductsData())
    }, []);

    const classes = useStyles();
    return (<>
            <Container className={classes.header}>
                <Grid container justifyContent='space-between'>
                    <Grid item xs={6} md={4}>
                        <form onSubmit={handleSubmit}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Button size='large' type='submit' variant='outlined'>ثبت</Button>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField label="قیمت روز درهم" size="small" placeholder={aedPrice} inputRef={aedRef}/>
                                </Grid>
                            </Grid>
                        </form>

                    </Grid>
                    <Grid item xs={4} md={2}>
                        <TextField label="جستجو" type="text" size="small"
                                   onChange={e => setSearchPhrase(e.target.value.toLowerCase())}/>

                    </Grid>
                </Grid>
            </Container>
            <Container maxWidth='lg'>
                <List>
                    {products.filter(product => product.fullName.toLocaleLowerCase().match(searchPhrase)).map(product => (
                        <ListItem alignItems="flex-start" className={classes.item} to={`/products/${product.id}`}
                                  component={Link}>
                            <ListItemAvatar>
                                <Avatar sx={{
                                    height: '60px',
                                    width: '60px',
                                    fontWeight: 'bolder',
                                    bgcolor: avatarColor(product.profit)
                                }}>{product.profit}%</Avatar>
                            </ListItemAvatar>
                            <ListItemText

                                primary={product.fullName}
                                primaryTypographyProps={{color: 'primary', textAlign:'start', paddingRight:'100px'}}
                                secondary={
                                    <Grid container>
                                        <Grid item xs={3}>
                                            خرید: {IRRFormatter.format(product.cost)}
                                        </Grid>
                                        <Grid item xs={3}>
                                            فروش: {IRRFormatter.format(product.price)}
                                        </Grid>
                                        <Grid item xs={3}>
                                            جایگاه دی‌جی کالا: {product.dgPosition}
                                        </Grid>
                                        <Grid item xs={3}>
                                            قیمت ارزی: {AEDFormatter.format((product.aedPrice))}
                                        </Grid>

                                    </Grid>
                                }
                            />
                        </ListItem>
                    ))}
                </List>

            </Container>
        </>
    )
}


const useStyles = makeStyles(theme => ({
    header: {
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        backgroundColor: 'white',
        borderBottom: '2px solid black'
    },
    item: {
        backgroundColor: '#fafafa',
        transitionDuration: 300,
        cursor: 'pointer',
        borderRadius: theme.spacing(4),
        '&:hover': {
            filter: 'brightness(.8)'
        },
        marginBottom: theme.spacing(2)
    }
}))

function calculateProfit(product) {
    const profit = (product.cost != 0 ? (product.price - product.cost) / product.cost : 0);
    return Math.round(1000 * profit) / 10
}

function avatarColor(profit) {
    const color = profit > 0 ? green : deepOrange;
    const level = Math.min(Math.floor(Math.abs(profit) / 5), 7);
    console.log(level)
    return color[200 + level * 100]

}
